import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AtlasButtonComponent } from '@ui/components/atlas-button/atlas-button.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[wsbAppDebounceClick]',
  standalone: false
})
export class PreventMultipleClicksDirective implements OnInit, OnDestroy {
  @Input() buttonRef: AtlasButtonComponent;
  private debounceTime = 250;

  @Output()
  debounceClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.subscription = this.clicks.pipe(debounceTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.buttonRef.disabled) {
      this.buttonRef.disabled = true;
      this.clicks.next(event);
    }
  }
}
